



















































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { IState } from "@/store";
import { DataModules } from "@/store/modules/data";
import eventsMap from "@/components/app/global/timelineComponent/events";
import { INotificationHook } from "@/models/notifications";
import { ITemplate } from "@/models/templates";
import { TemplateTypes } from "@/data/enums/templates";

@Component({
  components: {
    "templates-provider": () =>
      import("@/components/app/global/templates/templatesProvider.vue"),
    "templates-notifications-table-view": () =>
      import(
        "@/components/app/global/templates/notifications/templatesNotificationsTableView.vue"
      )
  },
  computed: {
    ...mapState({
      hook(state: IState, getters) {
        return getters[`data/single`]({
          id: this.hookId,
          storeModule: this.storeModule
        });
      }
    })
  }
})
export default class TriggerModal extends Vue {
  @Prop({ required: true })
  public hookId!: INotificationHook["id"];

  public hook!: INotificationHook;
  public isLoading = true;
  public isReloading = false;
  public requestError = false;
  public storeModule = DataModules.NOTIFICATIONS_HOOKS;
  public templateType = TemplateTypes.NOTIFICATION;

  public async created() {
    await this.getHook();
    this.isLoading = false;
  }

  public get hookName() {
    return eventsMap?.[this.hook?.code]?.name || this.hook?.name;
  }

  public async getHook() {
    try {
      await this.$store.dispatch(`data/${this.storeModule}/get`, {
        id: this.hookId,
        vm: this
      });
      this.requestError = false;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    }
    this.isLoading = false;
    this.isReloading = false;
  }

  public reloadData() {
    this.isReloading = true;
    this.getHook();
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binSingle", {
      storeModule: this.storeModule,
      vm: this
    });
  }

  public viewTemplate(template: ITemplate) {
    this.$emit("close");
    this.$router.push({
      name: "adminAutomationAction",
      params: { templateId: template.id }
    });
  }
}
